import { Email, EventData, IEventService, SimpleNotificationEvent } from '@price-for-profit/micro-services';

export type ICustomEventService = Pick<IEventService, 'sendSimpleEmail'>;

export class CustomEventService implements ICustomEventService {
    constructor(private eventService: IEventService, private environment: string) {}

    async sendSimpleEmail(email: Email): Promise<EventData> {
        if (this.environment === 'dev') {
            const notificiationEvent: SimpleNotificationEvent = {
                subject: email.subject,
                body: email.body,
                to: email.to,
                cc: email.cc,
                bcc: email.bcc,
            };

            console.log('Email Event', notificiationEvent);

            return {
                correlationId: 'dev-test',
            } as EventData;
        }
        const eventData = await this.eventService.sendSimpleEmail(email);

        return eventData;
    }
}
